export const members = [
	{
		name:'פרופ\' אד\' טליה מרגלית',
		title:'מייסדת ויו"ר ועד מנהל',
		order:1,
		photo:'talia'
		
	},
	{
		name:'רון ון ראלטה',
		title:'ועד מנהל',
		order:2,
		photo:'ron'
		
	},
	{
		name:'תומר צ\'ציק',
		title:'ועד מנהל',
		order:3,
		photo:'tomer'
		
	},
	{
		name:'ד"ר אד\' יונתן דורטהיימר ',
		title:'מייסד',
		order:4,
		photo:'yonatan'
	},
	{
		name:'אד\' איל מגדלוביץ',
		title:'מייסד ומנכ"ל',
		order:5,
		photo:'eyal'
		
	},
	{
		name:'דרור גבתון',
		title:'מנהל מוצר',
		order:6,
		photo:'dror'
		
	},
	{
		name:'גל גנדלר',
		title:'מנהלת פיתוח',
		order:7,
		photo:'gal'
		
	},
	{
		name:'כרם ואן מיל',
		title:'מנהלת קהילה',
		order:9,
		photo:'kerem'
		
	},
	{
		name:'גליה רופין',
		title:'ראש תחום סביבה',
		order:10,
		photo:'galia'
		
	},
	// {
	// 	name:`דור זומר`,
	// 	title:`שיווק ואסטרטגיה`,
	// 	order:11,
	// 	photo:'dor'
		
	// },
	{
		name:'לישי סוקול',
		title:'מעצב מוצר',
		order:11,
		photo:'lishay'
		
	},
	{
		name:'היבה בוארדי',
		title:'מחקר וייעוץ תכנוני',
		order:12,
		photo:'hiba'
		
	},
	// {
	// 	name:`יואב בן שלום`,
	// 	title:`צוות מוצר`,
	// 	order:13,
	// 	photo:'yoav'
		
	// },
	{
		name:'אד\' מרינה ירמוננוק',
		title:'מחקר וייעוץ תכנוני',
		order:14,
		photo:'marina'
		
	},
	{
		name:'נועה ויכנסקי',
		title:'עיצוב UX/UI',
		order:15,
		photo:'noa'
		
	},
	{
		name:'אד\' עידית מן',
		title:'מחקר וייעוץ תכנוני',
		order:16,
		photo:'idit'
		
	},
	// {
	// 	name:`רות אברהם `,
	// 	title:`מחקר וייעוץ תכנוני`,
	// 	order:17,
	// 	photo:'ruth'
		
	// },
	// {
	// 	name:`שרה גדז'`,
	// 	title:`מעצבת UI / UX`,
	// 	order:18,
	// 	photo:'sarah'
		
	// },
	{
		name:'תומר לאור',
		title:'מנהל נתונים',
		order:19,
		photo:'tomerL'
		
	},
	{
		name:'סאן דרי',
		title: 'DevOps',
		order:20,
		photo:'sun'
		
	},
	{
		name:'אד׳ טל ישי',
		title:'קידום מדיניות',
		order:21,
		photo:'tal'
		
	},
	{
		name:'אורי הירש',
		title:'מאפין UX',
		order:22,
		photo:'ori'
		
	},
	{
		name:'דניאל גל',
		title:'תיאום פרויקטים',
		order:23,
		photo:'daniel'
		
	},
	{
		name:'זיו אריאלי',
		title:'עיצוב UX/UI',
		order:16,
		photo:'ziv'
		
	},
	{
		name:'אופיר קירי',
		title:'קשרי קהילה',
		order:17,
		photo:'ofir'
		
	},
];

// // template
// {
// 		name:``,
// 		title:``,
// 		order:1,
// 		photo:'eyal'